import {useQuery} from '@tanstack/react-query';
import {PolicyFailReason} from '@common/billing/upgrade/policy-fail-reason';
import {apiClient} from '../http/query-client';

export interface AccountPlanSummary {
  name: string;
  ends_at: string | null;
  days_remaining: number | null;
  expires_soon: boolean;
  has_active_subscription: boolean;
  gateway_name: string | null;
}

interface AccountUsageResponse {
  plan?: AccountPlanSummary | null;
  projects: {
    published_used: number;
    create: {
      allowed: boolean;
      failReason?: PolicyFailReason;
    };
  };
}

function fetchAccountUsage() {
  return apiClient
    .get<AccountUsageResponse>('account/usage')
    .then(response => response.data);
}

export function useAccountPlan() {
  return useQuery({
    queryKey: ['account-usage'],
    queryFn: fetchAccountUsage,
    select: data => data.plan ?? null,
  });
}

export function useAccountUsageSummary() {
  return useQuery({
    queryKey: ['account-usage'],
    queryFn: fetchAccountUsage,
    select: data => ({
      plan: data.plan ?? null,
      publishedUsed: data.projects.published_used,
      createAllowed: data.projects.create.allowed,
      createFailReason: data.projects.create.failReason,
    }),
  });
}
